import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/data/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate from={Route.fullPath} to="./companies" />
}
